import { Component, OnInit } from '@angular/core';
import {NbComponentStatus, NbDialogRef} from "@nebular/theme";

@Component({
    selector: 'bst-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {

  public title: string = "Are you Sure?";
  public subtitle: string = "Are you certain you want to do this action?";
  public notitle: string = 'no';
  public yestitle: string = 'yes'
  public info: boolean = false;
  public status: NbComponentStatus = 'primary';

  constructor(protected ref: NbDialogRef<ConfirmDialogComponent>) { }

  ngOnInit(): void {
  }

  cancel() {
    this.ref.close(false);
  }

  submit() {
    this.ref.close(true);
  }

}
